var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CaretDown } from 'phosphor-react';
import { theme } from '../../styles/theme';
import * as Styled from './Select.styles';
export const Select = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(Styled.Wrapper, Object.assign({ IconComponent: () => React.createElement(CaretDown, null) || props.IconComponent, MenuProps: {
            sx: {
                '& .MuiPaper-root': { boxShadow: theme.mixins.shadowLight },
                '& .MuiList-padding': {
                    padding: 0,
                },
                '& .Mui-selected': {
                    background: theme.colors.backgroundBrandLight,
                },
            },
        } }, props), props.children));
};
